import { RCCGrid } from "react-common-components";
import styled from "styled-components";

export const Lines = styled.div`
    display: flex;
    width: 100%;
    flex-wrap: wrap;
    margin: 4px 0;
    height: max-content;

    position: relative;

    .trashFixed{
      display: none;
      position: absolute;
      z-index: 10;
			top: -1rem;
			right: 0;
    }

    &:hover{
      .trashFixed{
        display: flex;
      }
    }
`;

export const Column = styled(RCCGrid)`
  padding: 2px;
`;
